// src/components/Cart/CartSidebarWrapper.jsx
import { lazy, Suspense, useEffect, useState } from '@wordpress/element';
import { useAppState } from '../../contexts/AppStateContext';
import LoadingSpinner from '../LoadingSpinner';

const CartSidebar = lazy(() => import('./CartSidebar'));

const CartSidebarWrapper = ({ forcedOrderType }) => {
    const { sidebarToggle } = useAppState();
    const [shouldRender, setShouldRender] = useState(false);
    const [animationClass, setAnimationClass] = useState('');

    useEffect(() => {
        if (sidebarToggle && !shouldRender) {
            setShouldRender(true);
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setAnimationClass('cart-sidebar-animate-in');
                    setTimeout(() => {
                        setAnimationClass('');
                    }, 350);
                });
            });
        }
    }, [sidebarToggle, shouldRender]);

    if (!shouldRender) {
        return null;
    }

    return (
        <div className={animationClass}>
            <Suspense fallback={<LoadingSpinner />}>
                <CartSidebar forcedOrderType={forcedOrderType} />
            </Suspense>
        </div>
    );
};

export default CartSidebarWrapper;
